import { useEffect, useState } from 'react';

const BoardToken = 'bd912bfa-6999-f722-92ff-2f1b145cde43';

function Support() {
  const [embedLoading, setEmbedLoading] = useState(true);
  useEffect(() => {
    (function (w: Window, d: Document, i: string, s: string) {
      function l() {
        if (!d.getElementById(i)) {
          const f = d.getElementsByTagName(s)[0];
          const e = d.createElement(s) as HTMLScriptElement;
          e.type = 'text/javascript';
          e.async = true;
          e.src = 'https://canny.io/sdk.js';
          f.parentNode?.insertBefore(e, f);
        }
      }

      if (typeof (w as any).Canny !== 'function') {
        const c = function () {
          (c as any).q.push(arguments);
        };
        (c as any).q = [];
        (w as any).Canny = c;

        if (d.readyState === 'complete') {
          l();
        } else {
          w.addEventListener('load', l, false);
        }
      }
    })(window, document, 'canny-jssdk', 'script');

    (window as any).Canny('render', {
      boardToken: BoardToken,
      basePath: null, // See step 2
      ssoToken: null, // See step 3,
      theme: 'light', // options: light [default], dark, auto
    });
    const timeout = window.setTimeout(() => setEmbedLoading(false), 1800);
    return () => window.clearTimeout(timeout);
  }, []);

  return (
    <div className="surface-card min-h-[50vh] p-8 sm:p-10">
      <p className="eyebrow">Support</p>
      <h1 className="mt-2 text-3xl font-black text-brand-midnight">How can we help?</h1>
      {embedLoading ? <p className="mt-3 text-sm text-gray-500" role="status">Loading the support board...</p> : null}
      <div className="mt-6 min-h-48 w-full" data-canny />
      <div className="mt-6 rounded-xl border border-gray-200 bg-gray-50 p-4 text-sm text-gray-600">
        If the support board does not load, email <a className="font-bold text-brand-cobalt underline" href="mailto:support@racetrainer.ai">support@racetrainer.ai</a> and include what you were trying to do.
      </div>
    </div>
  );
}

export default Support;
